/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { CosmosAsset } from "@components/elements/atoms";
import { HeroAlphaHeroImageProps } from "./HeroAlpha.HeroImage";
import { css } from "@panda/css";

const styles = css({
	position: "absolute",
	left: 0,
	right: 0,
	h: "100vh",
	"& img, & video, .cosmos-video-embed": {
		h: "full",
		objectFit: "cover",
	},
	"& .cosmos-attribution": {
		zIndex: "1",
	},
	overflow: "hidden",
});

const gradient = css({
	position: "absolute",
	h: "full",
	w: "full",
	top: 0,
	background: "linear-gradient(252deg, rgba(0, 0, 0, 0.00) 0%, rgba(16, 16, 20, 0.85) 100%)",
});

export const HeroAlphaFullWidthImage = ({ heroAsset }: HeroAlphaHeroImageProps): React.JSX.Element => {
	return (
		<div className={`hero-alpha-fullwidth-image ${styles}`}>
			<CosmosAsset className={css({ w: "full" })} asset={heroAsset} eager />
			<div className={gradient} />
		</div>
	);
};
